class MFRTwoColumnsCarousel {
  constructor(i, e, options) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      carousel: ".two-columns__carousel",
      nav: ".two-columns__nav",
    };

    this.options = options;

    this.init();
  }

  init() {
    this.$carousel = this.$element.find(this.selectors.carousel);

    this.initCarousel();
  }

  initCarousel() {
    this.$carousel.flickity({
      ...this.options,
      on: {
        ready: () => {
          setTimeout(this.initNavButtons.bind(this), 1000);
        },
        change: (i) => {
          this.$buttons.removeClass("disabled");
          if (i == 0) {
            $(this.$buttons[0]).addClass("disabled");
          } else if (i == this.$carousel.data("flickity").cells.length - 1) {
            $(this.$buttons[1]).addClass("disabled");
          }
        },
      },
    });
  }

  initNavButtons() {
    const nav = $(this.generateNav());
    this.$buttons = nav.find("button");
    this.$element.append(nav);

    this.$buttons.on("click", this.__handleNavClick.bind(this));
  }

  __handleNavClick(e) {
    const button = $(e.currentTarget);
    if (button.hasClass("prev")) this.$carousel.flickity("previous");
    else this.$carousel.flickity("next");
  }

  generateNav() {
    return `
      <div class="${this.selectors.nav.replace(".", "")}">
        <button class="prev disabled"></button>
        <button class="next"></button>
      </div>
    `;
  }
}